import ErrorStackParser from 'error-stack-parser';
import type { SentryStackFrame } from '../types';

export function normaliseError(err: unknown): {
	name: string;
	message: string;
	stack: string;
	frames: SentryStackFrame[];
	route: string;                 //  ←  NEW
} {
	const e = err instanceof Error ? err : new Error(String(err));
	const frames = ErrorStackParser.parse(e as Error).map<SentryStackFrame>((f) => ({
		file: f.fileName ?? '<unknown>',
		lineNumber: f.lineNumber ?? null,
		column: f.columnNumber ?? null,
		methodName: f.functionName ?? '<anon>',
	}));

	return {
		name: e.name,
		message: e.message,
		stack: e.stack ?? '',
		frames,
		route: typeof window !== 'undefined' ? window.location.pathname : '<ssr>', // NEW
	};
}
